export default "__VITE_ASSET__CGC8880H__"